import type { FooterColText } from '../../../types/footer';
import type { Translations } from '../../../types/translations';

export const mapText = ({
  col,
  index,
  translations,
  instance,
}: {
  col: FooterColText;
  index: number;
  translations?: Translations;
  instance?: string;
}) => {
  const text = col.st_elements.value[0];

  return {
    id: index,
    type: 'text',
    title:
      text?.st_title ||
      col.st_headline ||
      translations?.[`footer.column.headline.${index + 1}${instance === 'shop' ? '.shop' : ''}`] ||
      '',
    items: text?.st_text,
  } as const;
};
